import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Award, MessageSquare, Heart, Flame, Zap } from "lucide-react";
import api from "@/lib/api";
import { LevelBadge } from "@/components/UserBadge";

const TABS = [
  { k: "level", label: "Highest Level", Icon: Trophy },
  { k: "xp", label: "Most XP", Icon: Zap },
  { k: "comments", label: "Most Comments", Icon: MessageSquare },
  { k: "likes", label: "Most Likes", Icon: Heart },
  { k: "streak", label: "Longest Streak", Icon: Flame },
];

export default function Leaderboards() {
  const [kind, setKind] = useState("level");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/leaderboards", { params: { kind, limit: 10 } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [kind]);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="leaderboards-page">
      <div className="mb-8 text-center">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#FF9F0A] font-bold inline-flex items-center gap-1.5"><Trophy className="w-3 h-3" /> Rankings</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">Leaderboards</h1>
        <p className="text-zinc-400 mt-2 text-sm">The most savage members of the community.</p>
      </div>

      <div className="flex flex-wrap gap-2 justify-center mb-8">
        {TABS.map((t) => (
          <button key={t.k}
            data-testid={`lb-tab-${t.k}`}
            onClick={() => setKind(t.k)}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest border transition-all ${
              kind === t.k ? "bg-[#E50914] border-[#E50914] text-white shadow-[0_0_20px_rgba(229,9,20,0.4)]" : "bg-white/5 border-white/10 text-zinc-400 hover:text-white"
            }`}>
            <t.Icon className="w-3.5 h-3.5" /> {t.label}
          </button>
        ))}
      </div>

      <div className="glass rounded-2xl p-4 sm:p-6">
        <div className="space-y-2">
          {rows.map((u, i) => (
            <Link to={`/users/${u.id}`} key={u.id} className="flex items-center gap-4 p-3 rounded-xl bg-white/5 hover:bg-white/10 border border-white/5 transition-colors" data-testid={`lb-row-${i}`}>
              <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-black ${
                i === 0 ? "bg-[#FF9F0A]/20 text-[#FF9F0A] border border-[#FF9F0A]/40" :
                i === 1 ? "bg-white/10 text-white border border-white/20" :
                i === 2 ? "bg-[#E50914]/15 text-[#E50914] border border-[#E50914]/40" :
                "bg-white/5 text-zinc-400"
              }`}>{i + 1}</span>
              <span className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E50914] to-[#7a0309] flex items-center justify-center text-sm font-black uppercase overflow-hidden">
                {u.avatar ? <img src={u.avatar} alt="" className="w-full h-full object-cover" /> : (u.name || "?")[0]}
              </span>
              <div className="flex-1 min-w-0">
                <div className="font-bold truncate">{u.name}</div>
                <LevelBadge level={u.level} showBar={false} className="mt-0.5" />
              </div>
              <div className="text-right">
                <div className="font-display font-black text-lg text-[#E50914]">{Number(u.metric || 0).toLocaleString()}</div>
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold">{TABS.find((t) => t.k === kind)?.label}</div>
              </div>
            </Link>
          ))}
          {rows.length === 0 && <p className="text-center text-zinc-500 text-sm py-8">No data yet.</p>}
        </div>
      </div>
    </div>
  );
}
